import { CmsApiCategoryHighlightBlockData } from 'modules/cms/api/types/CmsApiCategoryHighlight';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpCategoryHighlightBlock } from './CmsAmpCategoryHighlightBlock';
import { CmsCategoryHighlightBlock } from './CmsCategoryHighlightBlock';

export const CategoryHighlightBlockMapping: CmsBlockMapping<CmsApiCategoryHighlightBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsCategoryHighlightBlock,
    AmpComponent: CmsAmpCategoryHighlightBlock,
  };
